// initial state
const state = () => ({
    plateNumber: '',
    manualPlate: '',
    processNumber: '',
    vehiclePhoto: 'Image Not Found',
    vehiclePhotoDefault: '/images/_templates/default-car.png',
    typeSearch: '',
    token: '',
    data: {},
    changedNumber: 0,
    newPlate: null,
    carNotes: null,
    plateSearch: null,
    dataSourceId: null,
    detailsData: [],
    availableMaintenanceModuls: []
})

// getters
const getters = {

  getState(state)
  {
      return state;
  },

  /**
   * Metodo get especifico para rastrear alterações
   * no objeto vehicleIdentification
   *
   * @param {*} state
   */
  getChangedVehicleIdentification(state)
  {
      return state.changedNumber;
  },

  getDataSourceId(state)
  {
      return state.dataSourceId;
  },

  getChangedVehicleIdentificationNewPlate(state)
  {
      return state.newPlate;
  },

  controlDetails(state)
  {
      let title = '';
      if (state.data.length)
      {
          state.data.filter((value, index) => {
              if (value.description == 'Make') {
                  title = value.value;
              }
              if (value.description == 'Model') {
                  title += ' ';
                  title += value.value;
              }
          });

      }

      return title;
  },

  getVehicleIdentificationNotes(state)
  {
      return state.carNotes;
  },

  getVehicleIdentificationAvailableMaintenanceModules(state) {
    return state.availableMaintenanceModuls;
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
    setVehicleIdentification(state, payload) {
        state.data = payload.data;
        state.typeSearch = payload.typeSearch;
        state.plateNumber = payload.plateNumber;
        state.processNumber = payload.processNumber;
        state.vehiclePhoto = payload.vehiclePhoto;
        state.token = payload.token;
        state.newPlate = null;
        state.carNotes = payload?.carNotes;
        state.dataSourceId = payload?.dataSourceId;
        state.detailsData = payload?.detailsData;
        state.manualPlate = payload?.manualPlate;

        this.commit('vehicleIdentification/setLocalStorage', state);
        state.changedNumber++;
    },

    setVehicleIdentificationNewPlateValid(state, payload) {
        state.newPlate = payload;
    },

    setVehicleIdentificationPlateSearch(state, payload) {
        state.plateSearch = payload.plate;
        if(payload.dataSourceId) {
            state.dataSourceId = payload.dataSourceId
        }
    },

    setLocalStorage(state, payload) {
        localStorage.setItem('lastVehicle', JSON.stringify(payload));
    },

    setVehicleIdentificationClear(state) {
        state.plateNumber = '';
        state.processNumber= '';
        state.vehiclePhoto= 'Image Not Found';
        state.vehiclePhotoDefault= '/images/_templates/default-car.png';
        state.typeSearch= '';
        state.token= '';
        state.data= {};
        state.newPlate = null;
        state.carNotes = null;
        state.dataSourceId = null;
        state.detailsData = [];

        this.commit('vehicleIdentification/setLocalStorage', state);
    },

    setVehicleIdentificationNotes(state, payload)
    {
        state.carNotes = payload;
        this.commit('vehicleIdentification/setLocalStorage', state);
    },

    setVehicleIdentificationDataSourceId(state, payload) {
        state.dataSourceId = payload;
    },

    setVehicleIdentificationDetailsData(state, payload) {
      state.detailsData = payload;
    },

    setVehicleIdentificationAvailableMaintenanceModules(state, payload) {
      state.availableMaintenanceModuls = payload;
    }
}

export default {
namespaced: true,
state,
getters,
actions,
mutations
}
